module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ29tcG9uZW50XzdfMjEiIGRhdGEtbmFtZT0iQ29tcG9uZW50IDcg4oCTIDIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDExIDE1Ij4KICA8cGF0aCBpZD0iUG9seWdvbl8yIiBkYXRhLW5hbWU9IlBvbHlnb24gMiIgZD0iTTUuNSwwLDExLDZIMFoiIGZpbGw9IiM3NDgxNzUiLz4KICA8cGF0aCBpZD0iUG9seWdvbl8zIiBkYXRhLW5hbWU9IlBvbHlnb24gMyIgZD0iTTUuNSwwLDExLDZIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExIDE1KSByb3RhdGUoMTgwKSIgZmlsbD0iIzc0ODE3NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-sort.svg
// module id = kyU+
// module chunks = 1